import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  CreateRepContactMutationMutation,
  CreateRepContactMutationMutationVariables,
} from "../../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../../types/NormalizedErrorMap";

export const createRepContactMutation = gql`
  mutation CreateRepContactMutation(
    $adminId: String!, 
    $role: String!
  ) {
    createRepContact(
      adminId: $adminId, 
      role: $role
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: CreateRepContactMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const CreateRepContact: React.FC<Props> = ({ children, onMessage }) => {
  const [_createRepContactMutation, { loading, error }] = useMutation<
    CreateRepContactMutationMutation,
    CreateRepContactMutationMutationVariables
  >(createRepContactMutation);

  const submit = async (
    values: CreateRepContactMutationMutationVariables
  ) => {
    const { data } = await _createRepContactMutation({
      variables: values,
    });

    const errors = data?.createRepContact?.errors
      ? normalizeErrors(data.createRepContact.errors)
      : null;

    if (data?.createRepContact?.message && onMessage) {
      onMessage(data.createRepContact.message);
    }

    return {
      errors,
      message: data?.createRepContact?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};
